

import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form10";
const form10State = namespace("Form10");

import { form10DataInfoType, form10PartiesInfoType } from '@/types/Information/Form10';
import {getPartyTitles, getFullName} from '../PartyTitlesForm10'

@Component
export default class Form10Layout extends Vue {

    @Prop({required:true})
    result!: form10DataInfoType; 

    @form10State.Action
    public UpdateForm10Info!: (newForm10Info: form10DataInfoType) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    
    applicantNamesFull='';
    respondentNamesFull='';
    appearingParties='';
    applyingParties=''

    signingPartyList =[]

    hearingDate = ''
    applicationType = ''


    mounted(){
        this.extractInfo();       
        this.dataReady = true;
    }
   
    public extractInfo(){        
       
        this.applicantNames = [];
        this.respondentNames = [];

        for (const resInx in this.result.respondents){
            const fullTitle = getPartyTitles(this.result.respondents[resInx],' ')
            this.respondentNames.push(fullTitle);            
        }
        this.respondentNamesFull=this.combineNames(this.result.respondents, '', this.respondentNames);

        for (const appInx in this.result.appellants){
            const fullTitle = getPartyTitles(this.result.appellants[appInx],' ')
            this.applicantNames.push(fullTitle);                        
        }
        this.applicantNamesFull = this.combineNames(this.result.appellants, '', this.applicantNames)
        
         
        this.hearingDate = this.result.judgmentReserved? this.result.judgmentReservedDate : this.result.dateOfJudgement;
        this.extractAppearingParties();
        this.extractApplyingParties();
        this.extractApplicationTypes();
    }

    public extractApplicationTypes(){

        const otherTypeIndex = this.result.applicationFor.findIndex(item =>item=='other')
        if(otherTypeIndex>-1){
            const applicationFor = JSON.parse(JSON.stringify(this.result.applicationFor))
            applicationFor.splice(otherTypeIndex,1)
            applicationFor.push(this.result.applicationForOther)

            this.applicationType = this.combineNames(applicationFor)
        }
        else 
            this.applicationType = this.combineNames(this.result.applicationFor)
    }

    public extractAppearingParties(){

        const appearingAppellants = this.result.appearingParties.filter(party=> !party.responding)
        const appearingRespondents = this.result.appearingParties.filter(party=> party.responding)
                               
        const appellantnames = this.combineNames(appearingAppellants, 'name', null, ', appellant')                   
        const respondentnames = this.combineNames(appearingRespondents, 'name', null, ', respondent')        

        this.extractSigningPartyList(appearingAppellants, appearingRespondents)

        this.appearingParties += appellantnames
        this.appearingParties += (appellantnames && respondentnames)?' and ':''
        this.appearingParties += respondentnames 
        this.appearingParties += (!appellantnames)?  ' and no one appearing on behalf of the appellant(s)':''
        this.appearingParties += (!respondentnames)? ' and no one appearing on behalf of the respondent(s)':''
    }

    public extractSigningPartyList(appearingAppellants, appearingRespondents){
        const allParties: form10PartiesInfoType[] = [...appearingAppellants, ...appearingRespondents]        
        this.signingPartyList =[]
        for(const party of allParties){
            if(!party.isCounsel){
                const sameParty = allParties.filter(par => {
                    return(
                        (par.organization && par.isOrganization && par.organization==party.organization) ||
                        (par.firstName && par.lastName && par.firstName == party.firstName && par.lastName == party.lastName)
                    )
                })
                if(sameParty.length==1) this.signingPartyList.push(party)
            }else{
                this.signingPartyList.push(party)
            }
        }
    }

    public extractApplyingParties(){
        
        const applyingAppellants = this.result.filingParties.filter(party=> !party.responding)
        const applyingRespondents = this.result.filingParties.filter(party=> party.responding)
                     
        const appellantnames = this.combineNames(applyingAppellants, 'name')            
        const respondentnames = this.combineNames(applyingRespondents, 'name')        

        this.applyingParties += appellantnames
        this.applyingParties += (appellantnames && respondentnames)?' and ':''
        this.applyingParties += respondentnames
    }
    
    public combineNames(names, nameField?, addingNameArray?, role?){
        let namesString = ''
        
        const numberOfNames = names.length       
        for(const index in names){
            
            let addingName = ''
            const partyRole = role? (role+  
                (!names[index].isCounsel && !names[index].isOrganization?', appearing in person':'')) 
            : ''            

            if(addingNameArray?.length>0){
                addingName = addingNameArray[index] + partyRole
            }
            else if(nameField)
                addingName = names[index][nameField] + partyRole
            else
                addingName = names[index] + partyRole

            if(Number(index)>0 && Number(index)+1 == numberOfNames)
                namesString += ' and '+addingName
            else if(Number(index)==0)
                namesString += addingName
            else
                namesString += ', '+addingName
        }
        return namesString
    }
}

